<template lang="pug">
div
    .box
        .box-header.dker
            h3 Add Stock
        .box-divider.m-a-0
        .box-body
            .row
                .col-md-4
                    stock-selector.m-t-0(
                        :exclude-supplier="supplier.id",
                        v-model="stock",
                        :disabled="onLoading('save-supplier-supplier')",
                        placeholder="Select Stock"
                    )
                    span.text-danger(v-if="errors.has('Stock', 'stock_add')") {{ errors.first('Stock', 'stock_add') }}

                .col-md-3
                    .form-group
                        input.form-control(
                            type="text",
                            placeholder="Supplier Price",
                            v-model="cost",
                            key="supplier-cost",
                            name="Supplier price",
                            :disabled="onLoading('save-supplier-supplier')",
                            v-validate="'required|decimal:2|min_value:0'",
                            data-vv-scope="stock_add"
                        )
                        span.text-danger(v-if="errors.has('Supplier price', 'stock_add')") {{ errors.first('Supplier price', 'stock_add') }}
                .col-md-2
                    button.md-btn.md-raised.m-b-sm.w-xs.green(
                        :disabled="onLoading('save-supplier-supplier')",
                        @click="submit"
                    )
                        v-loading(loader="save-supplier") Add

                    
    .box
        .box-header.dker
            h3 {{ supplier.name }} - Stock List
        .box-divider.m-a-0
        v-server-table(
            ref="datatable", 
            :url="api",
            :name="tableName",
            :columns="columns", 
            :options="options"
        )  
            template(slot="supplier_price", slot-scope="props")
                input.form-control.w-xs.input-xs(
                    :class="{ 'has-error': errors.has('Price', 'stock_update') }",
                    v-if="editRow == props.row.id"
                    type="text",
                    name="Price",
                    :id="`row_${props.row.id}`",
                    :key="`row_${props.row.id}`",
                    :disabled="onLoading('save-supplier-supplier')",
                    :placeholder="props.row.pivot.cost",
                    v-validate="'required|decimal:2|min_value:0'",
                    data-vv-scope="stock_update"
                )
                span(v-else) {{ props.row.pivot.cost }}
            
            template(slot="action", slot-scope="props")
                button.btn.green.btn-sm.no-rowcallback(
                    v-if="editRow == props.row.id",
                    type="button",
                    :disabled="onLoading('save-supplier-supplier')",
                    @click="updateStock(props.row.id)"
                )
                    i.material-icons.no-rowcallback save
                
                button.btn.white.btn-sm.m-l-xs.no-rowcallback(
                    v-if="editRow == props.row.id",
                    type="button",
                    :disabled="onLoading('save-supplier-supplier')",
                    @click="cancelEdit"
                )
                    i.material-icons.no-rowcallback.text-muted close
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    props: {
        supplierId: {
            type: Number,
            required: true,
        },
    },

    data() {
        var that = this;

        return {
            stock: null,
            cost: null,
            editRow: null,
            tableName: 'VUETABLE_SUPPLIER_STOCKS',
            columns: [
                'name',
                'sku',
                'barcode',
                'price',
                'supplier_price',
                'action',
            ],
            options: {
                headings: {
                    action: '',
                    price: 'Selling Price',
                },
                sortable: ['name', 'sku', 'barcode', 'price'],
                checkbox: {
                    api_delete: Laroute.route('supplier.delete_stock', {
                        id: this.supplierId,
                    }),
                    delete_title: 'Remove Stock',
                },
                rowClassCallback: row => {
                    if (this.editRow == row.id) {
                        return 'dker pointer';
                    }

                    return 'pointer';
                },
                rowClickCallback: (row, event) => {
                    if ($(event.target).hasClass('no-rowcallback')) return;
                    this.editRow = row.id;

                    setTimeout(() => {
                        $(`#row_${row.id}`).focus();
                    }, 100);
                },
                csv_url: Laroute.route('supplier.export_stocks', {
                    type: 'csv',
                    id: this.supplierId,
                }),
                pdf_url: Laroute.route('supplier.export_stocks', {
                    type: 'pdf',
                    id: this.supplierId,
                }),
                xls_url: Laroute.route('supplier.export_stocks', {
                    type: 'xlsx',
                    id: this.supplierId,
                }),
                columnsClasses: {
                    supplier_price: 'w-xs text-nowrap p-a-sm text-center',
                    action: 'w-xs text-nowrap',
                },
            },
        };
    },

    computed: {
        ...mapGetters('supplier', ['supplier']),

        api() {
            return Laroute.route('supplier.stocks', { id: this.supplier.id });
        },
    },

    mounted() {
        this.$store.dispatch(`${this.tableName}_CHECKBOX/clearSelected`);
    },

    methods: {
        ...mapActions('supplier', ['saveSupplierStock']),
        ...mapActions('stock', ['getStockList']),

        async submit() {
            let hasError = false;
            this.errors.clear('stock_add');

            if (!(await this.$validator.validateAll('stock_add')))
                hasError = true;

            if (this.stock === null) {
                this.errors.add({
                    field: 'Stock',
                    msg: 'Stock field is required',
                    scope: 'stock_add',
                });

                hasError = true;
            }

            if (hasError) return;

            await this.saveSupplierStock({
                stock_id: this.stock.id,
                cost: this.cost,
            });

            this.stock = null;
            this.cost = null;

            this.getStockList({ exclude_supplier: this.supplier.id });
            this.$refs.datatable.getData();
        },

        cancelEdit() {
            this.editRow = null;
        },

        async updateStock(stock_id) {
            if (!(await this.$validator.validateAll('stock_update'))) return;

            const cost = $(`#row_${stock_id}`).val();

            await this.saveSupplierStock({
                stock_id,
                cost,
            });

            this.editRow = null;
            this.$refs.datatable.getData();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/supplier/supplier-stock-list.vue